import { Routes } from "../../../interface/routes.interface";
import { LabourController } from "../controllers/labour.controller";
import { Router } from "express";
import { authMiddleware, restrictToSelfOrAdminCreator } from "../../../middlewares/authMiddleware";
import { permissionInjector } from "../../../middlewares/permissionInjector";
import { validationMiddleware } from "../../../middlewares/validation.middleware";
import { updateLabourProfileSchema } from "../validation/labour.validation";
/**
 * @swagger
 * tags:
 *   name: Labour
 *   description: Labour management endpoints
 */
export class LabourRouter implements Routes {
    public path = '/labour';
    public labourController = new LabourController();
    public router = Router();

    constructor() {
        this.initializeRoutes();
    }

    public initializeRoutes() {
        /**
         * @swagger
         * /labour/{id}:
         *   put:
         *     summary: Update labour profile
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: path
         *         name: id
         *         required: true
         *         schema:
         *           type: string
         *         description: User ID of the labour profile
         *     requestBody:
         *       required: true
         *       content:
         *         application/json:
         *           schema:
         *             type: object
         *             properties:
         *               firstName:
         *                 type: string
         *                 example: John
         *               lastName:
         *                 type: string
         *                 example: Doe
         *               phone:
         *                 type: string
         *                 example: +1234567890
         *               countryCode:
         *                 type: string
         *                 example: +91
         *               profileImage:
         *                 type: string
         *                 example: 507f1f77bcf86cd799439011
         *               gender:
         *                 type: string
         *                 example: Male
         *               date_of_birth:
         *                 type: string
         *                 format: date
         *                 example: 1990-01-01
         *               age:
         *                 type: number
         *                 example: 30
         *               occupation:
         *                 type: string
         *                 example: Carpenter
         *               experienceSummary:
         *                 type: string
         *                 example: 5 years in carpentry
         *               tickets:
         *                 type: array
         *                 items:
         *                   type: string
         *                 example: ["SB", "SI"]
         *               certificates:
         *                 type: array
         *                 items:
         *                   type: object
         *                   properties:
         *                     name:
         *                       type: string
         *                     file:
         *                       type: string
         *                 example: [{ name: Basic Scaffolding (SB), file: 507f1f77bcf86cd799439012 }]
         *               identification:
         *                 type: array
         *                 items:
         *                   type: object
         *                   properties:
         *                     type:
         *                       type: string
         *                     file:
         *                       type: string
         *                     issuedAt:
         *                       type: string
         *                       format: date
         *                     expiresAt:
         *                       type: string
         *                       format: date
         *                 example: [{ type: Photo ID, file: 507f1f77bcf86cd799439013, issuedAt: 2023-01-01, expiresAt: 2028-01-01 }]
         *               skills:
         *                 type: array
         *                 items:
         *                   type: string
        *                 example: ["Electrician", "Plumber","Carpenter"]
         *               sitesInductedOn:
         *                 type: array
         *                 items:
         *                   type: string
         *                 example: [Site A, Site B]
         *     responses:
         *       200:
         *         description: Labour profile updated successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: string
         *                   example: success
         *                 message:
         *                   type: string
         *                   example: Labour profile updated successfully
         *                 data:
         *                   $ref: '#/components/schemas/Labour'
         *       400:
         *         description: Invalid input or missing required fields
         *       401:
         *         description: Unauthorized
         *       403:
         *         description: Forbidden
         *       404:
         *         description: Labour or user not found
         */
        this.router.put(
            `${this.path}/:id`,
            authMiddleware,
            // restrictToSelfOrAdminCreator,
            // validationMiddleware(updateLabourProfileSchema),
            // permissionInjector(`${this.path}`, 'PUT'),
            this.labourController.updateLabourProfile
        );

        /**
         * @swagger
         * /labour:
         *   get:
         *     summary: Get all labour profiles
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: query
         *         name: page
         *         schema:
         *           type: integer
         *           default: 1
         *         description: Page number
         *       - in: query
         *         name: limit
         *         schema:
         *           type: integer
         *           default: 10
         *         description: Number of labour profiles per page
         *       - in: query
         *         name: availability_status
         *         schema:
         *           type: string
         *         description: Filter by availability status
         *       - in: query
         *         name: search
         *         schema:
         *           type: string
         *         description: Search by name or email
         *       - in: query
         *         name: sortBy
         *         schema:
         *           type: string
         *           default: createdAt
         *         description: Field to sort by
         *       - in: query
         *         name: sortOrder
         *         schema:
         *           type: string
         *           default: desc
         *         description: Sort order (asc/desc)
         *     responses:
         *       200:
         *         description: Labour profiles retrieved successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: string
         *                   example: success
         *                 message:
         *                   type: string
         *                   example: Labour profiles retrieved successfully
         *                 data:
         *                   type: array
         *                   items:
         *                     $ref: '#/components/schemas/Labour'
         *                 total:
         *                   type: integer
         *                   example: 100
         *                 page:
         *                   type: integer
         *                   example: 1
         *                 totalPage:
         *                   type: integer
         *                   example: 10
         *       401:
         *         description: Unauthorized
         *       403:
         *         description: Forbidden
         */
        this.router.get(
            `${this.path}`,
            authMiddleware,
            permissionInjector(`${this.path}`, 'GET'),
            this.labourController.getAll
        );
        /**
        * @swagger
        * /labour/labourDashboard:
        *   get:
        *     summary: Ge labour Dashboard
        *     tags: [Labour]
        *     security:
        *       - bearerAuth: []
        *     responses:
        *       200:
        *         description: Labour Dashboard retrieved successfully
        *         content:
        *           application/json:
        *             schema:
        *               type: object
        *               properties:
        *                 status:
        *                   type: number
        *                   example: 200
        *                 message:
        *                   type: string
        *                   example: Successfully fetched Admin Dashboard
        *                 result:
        *                   type: object
        *                   properties:
        *                    user: 
        *                     $ref: '#/components/schemas/DashboardUser'
        *                    summary: 
        *                     $ref: '#/components/schemas/LabourSummary'
        *                    labour:
        *                     type: array
        *                     items:  
        *                      $ref: '#/components/schemas/LabourDetails'
        *                    allocationRequests:
        *                     type: array
        *                     items:  
        *                      $ref: '#/components/schemas/AllocationRequestSummary'
        *                    availableJobs:
        *                     type: array
        *                     items:  
        *                      $ref: '#/components/schemas/AvailableJob'
        *       401:
        *         description: Unauthorized
        *       403:
        *         description: Forbidden
        */
        this.router.get(
            `${this.path}/labourDashboard`,
            authMiddleware,
            this.labourController.labourDashboard
        );
        /**
         * @swagger
         * /labour/adminDashboard:
         *   get:
         *     summary: Get Admin Dashboard
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     responses:
         *       200:
         *         description: Admin Dashboard retrieved successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: number
         *                   example: 200
         *                 message:
         *                   type: string
         *                   example: Successfully fetched Admin Dashboard
         *                 result:
         *                   type: object
         *                   properties:
         *                    user: 
         *                     $ref: '#/components/schemas/DashboardUser'
         *                    summary: 
         *                     $ref: '#/components/schemas/DashboardSummary'
         *                    recentUpdates:
         *                     type: array
         *                     items:  
         *                      $ref: '#/components/schemas/RecentUpdate'
         *                    lastUpdated:
         *                     type: string
         *                     format: date-time  
         *                     example: "2025-07-04T15:15:30.178Z"
         *                    unreadChatCount:
         *                     type: integer  
         *                     example: 8
         *       401:
         *         description: Unauthorized
         *       403:
         *         description: Forbidden
         */
        this.router.get(
            `${this.path}/adminDashboard`,
            authMiddleware,
            this.labourController.adminDashboard
        );

        /**
         * @swagger
         * /labour/{id}:
         *   get:
         *     summary: Get labour profile by ID
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     parameters:
         *       - in: path
         *         name: id
         *         required: true
         *         schema:
         *           type: string
         *           pattern: '^[0-9a-fA-F]{24}$'
         *         description: User ID of the labour profile
         *     responses:
         *       200:
         *         description: Labour profile retrieved successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: string
         *                   example: success
         *                 message:
         *                   type: string
         *                   example: Labour profile retrieved successfully
         *                 data:
         *                   $ref: '#/components/schemas/Labour'
         *       400:
         *         description: Invalid ID
         *       401:
         *         description: Unauthorized
         *       403:
         *         description: Forbidden
         *       404:
         *         description: Labour profile not found
         */
        this.router.get(
            `${this.path}/:id([0-9a-fA-F]{24})`,
            authMiddleware,
            // permissionInjector(`${this.path}`, 'GET'),
            this.labourController.getLabourById
        );

        /**
         * @swagger
         * /labour/Skills:
         *   get:
         *     summary: Get all available skills
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     responses:
         *       200:
         *         description: Skills retrieved successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: string
         *                   example: OK
         *                 data:
         *                   type: array
         *                   items:
         *                     type: string
         *                   example: [Carpentry, Plumbing, Electrical]
         *       401:
         *         description: Unauthorized
         */
        this.router.get(
            `${this.path}/Skills`,
            // authMiddleware,
            this.labourController.getAllSkills
        );

        /**
         * @swagger
         * /labour/getOccupation:
         *   get:
         *     summary: Get all available skills
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     responses:
         *       200:
         *         description: Skills retrieved successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: string
         *                   example: OK
         *                 data:
         *                   type: array
         *                   items:
         *                     type: string
         *                   example: [Carpentry, Plumbing, Electrical]
         *       401:
         *         description: Unauthorized
         */
        this.router.get(
            `${this.path}/getOccupation`,
            // authMiddleware,
            this.labourController.getOccupation
        );
        /**
         * @swagger
         * /labour/getTickets:
         *   get:
         *     summary: Get all available skills
         *     tags: [Labour]
         *     security:
         *       - bearerAuth: []
         *     responses:
         *       200:
         *         description: Skills retrieved successfully
         *         content:
         *           application/json:
         *             schema:
         *               type: object
         *               properties:
         *                 status:
         *                   type: string
         *                   example: OK
         *                 data:
         *                   type: array
         *                   items:
         *                     type: string
         *                   example: [Carpentry, Plumbing, Electrical]
         *       401:
         *         description: Unauthorized
         */
        this.router.get(
            `${this.path}/getTickets`,
            // authMiddleware,
            this.labourController.getTickets
        );

        // /**
        //  * @swagger
        //  * /labour/verify/{id}:
        //  *   put:
        //  *     summary: Update labour verification status
        //  *     tags: [Labour]
        //  *     security:
        //  *       - bearerAuth: []
        //  *     parameters:
        //  *       - in: path
        //  *         name: id
        //  *         required: true
        //  *         schema:
        //  *           type: string
        //  *         description: User ID of the labour profile
        //  *     requestBody:
        //  *       required: true
        //  *       content:
        //  *         application/json:
        //  *           schema:
        //  *             type: object
        //  *             required: [verification_status]
        //  *             properties:
        //  *               verification_status:
        //  *                 type: string
        //  *                 enum: [PENDING, APPROVED, REJECTED]
        //  *                 example: APPROVED
        //  *               remarks:
        //  *                 type: string
        //  *                 nullable: true
        //  *                 example: Profile verified successfully
        //  *               rejectionReason:
        //  *                 type: string
        //  *                 nullable: true
        //  *                 example: Missing required documents
        //  *     responses:
        //  *       200:
        //  *         description: Verification status updated successfully
        //  *         content:
        //  *           application/json:
        //  *             schema:
        //  *               type: object
        //  *               properties:
        //  *                 status:
        //  *                   type: string
        //  *                   example: success
        //  *                 message:
        //  *                   type: string
        //  *                   example: Verification status updated
        //  *                 data:
        //  *                   type: object
        //  *                   properties:
        //  *                     _id:
        //  *                       type: string
        //  *                     verification_status:
        //  *                       type: string
        //  *                     remarks:
        //  *                       type: string
        //  *                       nullable: true
        //  *                     userId:
        //  *                       type: string
        //  *       400:
        //  *         description: Invalid verification status
        //  *       401:
        //  *         description: Unauthorized
        //  *       403:
        //  *         description: Forbidden
        //  *       404:
        //  *         description: Labour profile not found
        //  */
        // this.router.put(
        //     `${this.path}/verify/:id`,
        //     authMiddleware,
        //     permissionInjector(`${this.path}/verify`, 'PUT'),
        //     this.labourController.updateVerificationStatus
        // );

        // /**
        //  * @swagger
        //  * /labour/availability/{id}:
        //  *   patch:
        //  *     summary: Update labour availability status
        //  *     tags: [Labour]
        //  *     security:
        //  *       - bearerAuth: []
        //  *     parameters:
        //  *       - in: path
        //  *         name: id
        //  *         required: true
        //  *         schema:
        //  *           type: string
        //  *         description: User ID of the labour profile
        //  *     requestBody:
        //  *       required: true
        //  *       content:
        //  *         application/json:
        //  *           schema:
        //  *             type: object
        //  *             required: [availability_status]
        //  *             properties:
        //  *               availability_status:
        //  *                 type: string
        //  *                 enum: [AVAILABLE, UNAVAILABLE, ON_LEAVE]
        //  *                 example: AVAILABLE
        //  *     responses:
        //  *       200:
        //  *         description: Availability status updated successfully
        //  *         content:
        //  *           application/json:
        //  *             schema:
        //  *               type: object
        //  *               properties:
        //  *                 status:
        //  *                   type: string
        //  *                   example: success
        //  *                 message:
        //  *                   type: string
        //  *                   example: Status updated successfully
        //  *                 data:
        //  *                   type: object
        //  *                   properties:
        //  *                     _id:
        //  *                       type: string
        //  *                     availability_status:
        //  *                       type: string
        //  *                     userId:
        //  *                       type: string
        //  *       400:
        //  *         description: Invalid availability status
        //  *       401:
        //  *         description: Unauthorized
        //  *       403:
        //  *         description: Forbidden
        //  *       404:
        //  *         description: Labour profile not found
        //  */
        // this.router.patch(
        //     `${this.path}/availability/:id`,
        //     authMiddleware,
        //     restrictToSelfOrAdminCreator,
        //     permissionInjector(`${this.path}/availability`, 'PATCH'),
        //     this.labourController.updateAvailabilityStatus
        // );
    }
}

/**
 * @swagger
 * components:
 *   schemas:
 *     Labour:
 *       type: object
 *       properties:
 *         _id:
 *           type: string
 *           example: 507f1f77bcf86cd799439011
 *         userId:
 *           type: string
 *           example: 507f1f77bcf86cd799439012
 *         email:
 *           type: string
 *           format: email
 *           example: labour@example.com
 *         firstName:
 *           type: string
 *           example: John
 *         lastName:
 *           type: string
 *           example: Doe
 *         phone:
 *           type: string
 *           example: +1234567890
 *         countryCode:
 *           type: string
 *           example: +91
 *         profileImage:
 *           type: object
 *           nullable: true
 *           properties:
 *             _id:
 *               type: string
 *               example: 507f1f77bcf86cd799439013
 *             filename:
 *               type: string
 *               example: profile.jpg
 *             url:
 *               type: string
 *               example: https://s3.amazonaws.com/bucket/profile.jpg
 *             uploadedBy:
 *               type: string
 *               nullable: true
 *         status:
 *           type: string
 *           example: ACTIVE
 *         gender:
 *           type: string
 *           example: Male
 *         employee_id:
 *           type: string
 *           example: EMP123
 *         skills:
 *           type: array
 *           items:
 *             type: string
 *           example: [Carpentry, Plumbing]
 *         availability_status:
 *           type: string
 *           example: AVAILABLE
 *         profileCompletionStatus:
 *           type: string
 *           example: COMPLETED
 *         experienceSummary:
 *           type: string
 *           example: 5 years in carpentry
 *         tickets:
 *           type: array
 *           items:
 *             type: string
 *           example: [White Card, Forklift License]
 *         sitesInductedOn:
 *           type: array
 *           items:
 *             type: string
 *           example: [Site A, Site B]
 *         occupation:
 *           type: string
 *           example: Carpenter
 *         certificates:
 *           type: array
 *           items:
 *             type: object
 *             properties:
 *               name:
 *                 type: string
 *               file:
 *                 type: object
 *                 nullable: true
 *                 properties:
 *                   _id:
 *                     type: string
 *                   filename:
 *                     type: string
 *                   url:
 *                     type: string
 *                   uploadedBy:
 *                     type: string
 *                     nullable: true
 *           example: [{ name: White Card, file: { _id: "507f1f77bcf86cd799439014", filename: "white_card.pdf", url: "https://s3.amazonaws.com/bucket/white_card.pdf" } }]
 *         identification:
 *           type: array
 *           items:
 *             type: object
 *             properties:
 *               type:
 *                 type: string
 *               file:
 *                 type: object
 *                 nullable: true
 *                 properties:
 *                   _id:
 *                     type: string
 *                   filename:
 *                     type: string
 *                   url:
 *                     type: string
 *                   uploadedBy:
 *                     type: string
 *                     nullable: true
 *               issuedAt:
 *                 type: string
 *                 format: date
 *                 nullable: true
 *               expiresAt:
 *                 type: string
 *                 format: date
 *                 nullable: true
 *           example: [{ type: Photo ID, file: { _id: "507f1f77bcf86cd799439015", filename: "photo_id.jpg", url: "https://s3.amazonaws.com/bucket/photo_id.jpg" }, issuedAt: "2023-01-01", expiresAt: "2028-01-01" }]
 *     DashboardUser:
 *       type: object
 *       properties:
 *         _id:
 *           type: string
 *           example: 507f1f77bcf86cd799439011
 *         email:
 *           type: string
 *           format: email
 *           example: labour@example.com
 *         firstName:
 *           type: string
 *           example: John
 *         lastName:
 *           type: string
 *           example: Doe
 *         phone:
 *           type: string
 *           example: +1234567890
 *         countryCode:
 *           type: string
 *           example: +91
 *         profileImage:
 *           type: object
 *           nullable: true
 *           properties:
 *             _id:
 *               type: string
 *               example: 507f1f77bcf86cd799439013
 *             filename:
 *               type: string
 *               example: profile.jpg
 *             url:
 *               type: string
 *               example: https://s3.amazonaws.com/bucket/profile.jpg
 *             uploadedBy:
 *               type: string
 *               nullable: true
 *     DashboardSummary:
 *       type: object
 *       properties:
 *         totalJobs:
 *           type: integer
 *           example: 10
 *         openJobs:
 *           type: integer
 *           example: 10
 *         closedJobs:
 *           type: integer
 *           example: 10
 *         totalLaborers:
 *           type: integer
 *           example: 10
 *         availableLaborers:
 *           type: integer
 *           example: 10
 *         unavailableLaborers:
 *           type: integer
 *           example: 10
 *         totalAllocationRequests:
 *           type: integer
 *           example: 10
 *         pendingRequests:
 *           type: integer
 *           example: 10
 *         acceptedRequests:
 *           type: integer
 *           example: 10
 *         rejectedRequests:
 *           type: integer
 *           example: 10
 *         totalStaff:
 *           type: integer
 *           example: 10
 *     RecentJob:
 *       type: object
 *       properties:
 *         _id:
 *           type: string    
 *         companyName:
 *           type: string
 *         location:
 *           type: string
 *         noOfSpots:
 *           type: integer
 *         allotted:
 *           type: integer
 *         open:
 *           type: integer
 *         status:
 *           type: string
 *     RecentLabour:
 *       type: object
 *       properties:
 *         _id:
 *           type: string
 *           example: 507f1f77bcf86cd799439011
 *         employee_id:
 *           type: string
 *         availability_status:
 *           type: string
 *         lastName:
 *           type: string
 *         userId:
 *           type: object
 *           nullable: true
 *           properties:
 *             _id:
 *               type: string
 *               example: 507f1f77bcf86cd799439013
 *             email:
 *               type: string
 *             firstName:
 *               type: string
 *             lastName:
 *               type: string
 *     RecentAllocationRequest:
 *       type: object
 *       properties:
 *         _id:
 *           type: string
 *           example: 507f1f77bcf86cd799439011
 *         status:
 *           type: string
 *         respondedAt:
 *           type: string
 *         responseNotes:
 *           type: string
 *         userId:
 *           type: object
 *           nullable: true
 *           properties:
 *             _id:
 *               type: string
 *               example: 507f1f77bcf86cd799439013
 *             email:
 *               type: string
 *             firstName:
 *               type: string
 *             lastName:
 *               type: string
 *         jobId:
 *           type: object
 *           nullable: true
 *           properties:
 *             _id:
 *               type: string
 *               example: 507f1f77bcf86cd799439013
 *             companyName:
 *               type: string
 *             location:
 *               type: string

 *     LabourDetails:
 *       type: object
 *       properties:
 *         employeeId:
 *           type: string
 *           example: LBR-0004
 *         availabilityStatus:
 *           type: string
 *         profileCompletionStatus:
 *           type: string
 *           example: Completed
 *         profileCompletionPercentage:
 *           type: number
 *           example: 95.0
 *         averageRating:
 *           type: number
 *           example: 4.5
 *         ratingCount:
 *           type: number
 *           example: 4
 *         occupation:
 *           type: string
 *         tickets:
 *           type: array
 *           items:
 *            type: string
 *            example: ["White Card", "Working at Heights"]
 *         sitesInductedOn:
 *           type: array
 *           items:
 *            type: string
 *            example: ["Site A", "Site B"]
 *     AllocationRequestSummary:
 *       type: object
 *       properties:  
 *         pending:
 *           type: integer
 *           example: 1
 *         accepted:
 *           type: integer
 *           example: 1
 *         rejected:
 *           type: integer
 *           example: 1
 *     AvailableJob:
 *       type: object
 *       properties:
 *         _id:
 *           type: string    
 *         companyName:
 *           type: string
 *         location:
 *           type: string
 *         noOfSpots:
 *           type: integer
 *         allotted:
 *           type: integer
 *         open:
 *           type: integer
 *         status:
 *           type: string
 *         startDate:
 *           type: string
 *         endDate:
 *           type: string
 *     LabourSummary:
 *       type: object
 *       properties:
 *         totalAccepted:
 *           type: integer
 *         unreadChatCount:
 *           type: integer
 *         upcomingWork:
 *           type: integer
 *         lastUpdated:
 *           type: string
 *     RecentUpdate:
 *       type: object
 *       required:
 *         - type
 *         - timestamp
 *         - data
 *       properties:
 *         type:
 *           type: string
 *           enum:
 *             - job
 *             - labour
 *             - allocationRequest
 *             - pendingAllocationRequest
 *             - onboardedLabour
 *           example: "onboardedLabour"
 *           description: The category of the update
 *         timestamp:
 *           type: string
 *           format: date-time
 *           example: "2025-07-11T13:00:00.000Z"
 *           description: The timestamp of the update
 *         status:
 *           type: string
 *           nullable: true
 *           example: "onboarded"
 *           description: The status or action associated with the update (e.g., Open, Active, accepted)
 *         data:
 *           oneOf:
 *             - $ref: '#/components/schemas/RecentJob'
 *             - $ref: '#/components/schemas/RecentLabour'
 *             - $ref: '#/components/schemas/RecentAllocationRequest'
 *             - $ref: '#/components/schemas/AllocationRequest'
 *             - $ref: '#/components/schemas/DashboardUser'
 *           description: The detailed data object corresponding to the update type
 *       example:
 *         - type: "onboardedLabour"
 *           timestamp: "2025-07-11T13:00:00.000Z"
 *           status: "onboarded"
 *           data:
 *             _id: "685d0c6be4fe6b473ad7c4e7"
 *             email: "michaelb3@ninjatechnolabs.com"
 *             firstName: "Michael"
 *             lastName: "Brown"
 *             profileImage: null
 *         - type: "job"
 *           timestamp: "2025-07-11T12:00:00.000Z"
 *           status: "Open"
 *           data:
 *             _id: "686e4e1ff88bfc17266bf38f"
 *             companyName: "Gold Rush"
 *             location: "Test Location"
 *             noOfSpots: 15
 *             status: "Open"
 *             open: 15
 *             allotted: 0
 *             createdAt: "2025-07-09T11:10:23.619Z"
 *             srno: "032"
*/
